var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url && !_vm.path)?_c('a',{staticClass:"ui-link",attrs:{"href":_vm.url}},[_vm._t("default")],2):(!_vm.url && _vm.path)?_c('router-link',{staticClass:"ui-link",attrs:{"tag":"a","to":_vm.path}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }